import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize, Subject, takeUntil } from 'rxjs';
import { IPlan } from '@gray/domain/models/plan/plan.model';
import { CoachStudentPlanService } from '../../../../core/services/coach-student-plan.service';

/** Takes a ready-made plan back off the student's planner, with everything it had added. */
@Component({
  selector: 'coach-planner-delete-plan-modal',
  templateUrl: './planner-delete-plan-modal.component.html',
  styleUrl: './planner-delete-plan-modal.component.scss',
})
export class PlannerDeletePlanModalComponent implements OnInit, OnDestroy {
  @Input() studentId!: number;
  @Input() periodId!: number;

  plans: IPlan[] = [];

  isLoading = false;
  removingPlanId?: number;

  destroyed$ = new Subject();

  constructor(
    public modal: NgbActiveModal,
    private planService: CoachStudentPlanService,
  ) {
  }

  ngOnInit(): void {
    this.getAppliedPlans();
  }

  getAppliedPlans() {
    this.isLoading = true;
    this.planService.getAppliedPlans(this.studentId, this.periodId)
      .pipe(takeUntil(this.destroyed$), finalize(() => this.isLoading = false))
      .subscribe(r => {
        this.plans = (r.data ?? []) as IPlan[];
      });
  }

  remove(plan: IPlan) {
    this.removingPlanId = plan.id;
    this.planService.rollbackPlan(this.studentId, plan.id, this.periodId)
      .pipe(takeUntil(this.destroyed$), finalize(() => this.removingPlanId = undefined))
      .subscribe(() => this.modal.close(true));
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
